import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import Nav from './components/Nav';
import Card from './components/Card';
import Day from './container/Day';
import Month from './container/Month';
import Year from './container/Year';
import Compare from './container/Compare';
import DefaultPage from './container/DefaultPage';

const ROUTES_DATA = [
  { id: 0, path: 'transactions', component: DefaultPage },
  { id: 1, path: 'day', component: Day },
  { id: 2, path: 'monthly', component: Month },
  { id: 3, path: 'year', component: Year },
  { id: 4, path: 'compare', component: Compare },
];

function Transactions() {
  return (
    <Card className="h-full">
      <Nav />
      <Routes>
        <Route index element={<Navigate replace to="transactions" />} />
        <Route index element={<DefaultPage />} />
        {ROUTES_DATA.map(({ id, path, component: Component }) => (
          <Route key={id} path={path} element={<Component />} />
        ))}
      </Routes>
    </Card>
  );
}

export default Transactions;
